import type { Observable } from 'rxjs';
import type {
  LeaderboardTriviaAnswerResult,
  LeaderboardTriviaToday,
  TriviaAnswerLetter,
} from '../models/leaderboard-trivia.model';

export interface LoadTodayTriviaParams {
  commerceId: number;
  leaderboardId: string;
  uid: string;
}

export interface SubmitTriviaAnswerParams {
  commerceId: number;
  leaderboardId: string;
  uid: string;
  day: number;
  answer: TriviaAnswerLetter;
}

export abstract class LeaderboardTriviaPort {
  abstract loadToday(params: LoadTodayTriviaParams): Observable<LeaderboardTriviaToday | null>;

  abstract submitAnswer(params: SubmitTriviaAnswerParams): Observable<LeaderboardTriviaAnswerResult | null>;
}
